import { render } from "./Nodeinfos.vue?vue&type=template&id=b0983686"
import script from "./Nodeinfos.vue?vue&type=script&lang=js"
export * from "./Nodeinfos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__